import React, { useEffect, useState } from "react";
import { nanoid } from "nanoid";
import { useDispatch, useSelector } from "react-redux";
import { getAllClasses, setClass, setSection, setSections } from "../features/studentSlice";

const Filter = ({formstate, handleState, handleSubmit}) => {
  const dispatch = useDispatch();
  const [sectionlist, setSectionList] = useState([]);
  const selectedClass = useSelector((state) => state.student.class);
  const selectedSection = useSelector((state) => state.student.section);
  const classesData = useSelector((state) => state.student.classes);
  const sections = useSelector((state) => state.student.sections);

  useEffect(() => {
    dispatch(getAllClasses())
  }, [])

  const getSectionsByClass = (classname) => {
    const Class = classesData.find((c) => c.name === classname);
    dispatch(setSections(Class.section));
  };

  const classesList =
  classesData &&
  classesData.map((el, index) => {
    return (
      <option key={index} value={el.name} className="capitalize">
        {el.name}
      </option>
    );
  });

  const sectionList = sections && sections.map((sec) => {
    return (
      <option key={nanoid()} value={sec} className="capitalize">
        {sec}
      </option>
    );
  });


  return (
    <div>
      <div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
          className="flex gap-4 justify-start items-end border-2 border-gray-100 p-8 rounded-xl"
        >
          <div className="flex flex-col w-full">
            <label htmlFor="class" className="font-semibold text-gray-800">
              Class
            </label>
            <select
              id="class"
              name="class"
              value={selectedClass}
              onChange={(e) => {
                dispatch(setClass(e.target.value));
                getSectionsByClass(e.target.value);
              }}
              className="p-3 text-gray-800 text-sm font-medium rounded-md bg-gray-100"
            >
              <option value="">Select Class</option>
              {classesList}
            </select>
          </div>

          <div className="flex flex-col w-full">
            <label htmlFor="section" className="font-semibold text-gray-800">
              Section
            </label>
            <select
              id="section"
              name="section"
              value={selectedSection}
              onChange={(e) => dispatch(setSection(e.target.value))}
              className="p-3 text-gray-800 text-sm capitalize font-medium rounded-md bg-gray-100"
            >
              <option value="" className="capitalize">Select Section</option>
              {sectionList}
            </select>
          </div>

          <button
            type="submit"
            className="bg-gray-100 text-gray-800 font-semibold p-3 shadow h-max w-full text-sm font-medium rounded-md"
          >
            Get Student's List
          </button>
        </form>
      </div>
    </div>
  );
};

export default Filter;
